import { AuthenticatedTemplate } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import { Login } from '../../../Login';
import Hero from "../../common/layout/Hero";
import HeroBody from "../../common/layout/HeroBody";
import Container from "../../common/layout/Container";
import { ThorProvider } from "../context/ThorContext";
import AudiencesManagerPage from "../components/AudiencesManagerPage";
import ThorToast from "../components/ThorToast";
import "../css/thor.css";

const ThorAudiencesContent = () => (
    <>
        <Container>
            <Hero>
                <HeroBody>
                    <p className="title is-1">Thor</p>
                    <p className="subtitle is-5 has-text-grey">Experiment management — design, review, run, and analyze A/B tests.</p>
                </HeroBody>
            </Hero>

            <div className="tabs mb-4">
                <ul>
                    <li><Link to="/thor/experiments">Experiments</Link></li>
                    <li className="is-active"><Link to="/thor/audiences">Audience Library</Link></li>
                    <li><Link to="/thor/exclusion-groups">Exclusion Groups</Link></li>
                    <li><Link to="/thor/resurrector">Resurrector</Link></li>
                </ul>
            </div>

            <div className="box">
                <p className="subtitle is-5 mb-1">Audience Library</p>
                <p className="has-text-grey is-size-7 mb-4">Named user segments you can attach to experiments. Each audience is built on an attribute (a user dimension like locale or deviceType) with a match rule.</p>
                <AudiencesManagerPage />
            </div>
        </Container>
        <ThorToast />
    </>
);

export const ThorAudiencesPage = () => (
    <>
        <Login />
        <AuthenticatedTemplate>
            <ThorProvider>
                <ThorAudiencesContent />
            </ThorProvider>
        </AuthenticatedTemplate>
    </>
);

export default ThorAudiencesPage;
